import * as React from 'react';
import { Table, Tag, Button, Space } from 'antd';
import { EditOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import moment from 'moment';

type Props = {
  supplier: Object,
  onClickEditSupplierItem: Function,
  onClickNewSupplierItem: Function,
}

export default class extends React.PureComponent<Props> {

  render() {
    const {
      supplier,
      onClickEditSupplierItem,
      onClickNewSupplierItem,
    } = this.props;

    const items = supplier.items || [];

    const columns = [
      {
        title: 'Item Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
          <React.Fragment>
            <div style={{ fontWeight: 500 }}>{record.name}</div>
            {record.description && (
              <div style={{ fontSize: 12, color: '#999' }}>{record.description}</div>
            )}
            {record.category === 'Paint & Coatings' && (record.paint_coverage_per_litre || record.paint_carbon_per_litre) && (
              <div style={{ fontSize: 11, color: '#1890ff', marginTop: 2 }}>
                {record.paint_coverage_per_litre && <span>Coverage: {record.paint_coverage_per_litre} m²/L</span>}
                {record.paint_coverage_per_litre && record.paint_carbon_per_litre && <span style={{ margin: '0 6px' }}>·</span>}
                {record.paint_carbon_per_litre && <span>Carbon: {record.paint_carbon_per_litre} kg CO₂/L</span>}
              </div>
            )}
          </React.Fragment>
        )
      },
      {
        title: 'Code/SKU',
        dataIndex: 'item_code',
        key: 'item_code',
        width: 120,
      },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        width: 150,
      },
      {
        title: 'Manufacturer',
        dataIndex: 'manufacturer',
        key: 'manufacturer',
        width: 140,
        render: (manufacturer) => manufacturer || '-'
      },
      {
        title: 'Unit Price',
        dataIndex: 'unit_price',
        key: 'unit_price',
        width: 120,
        render: (price, record) => (
          <span>
            {record.currency === 'GBP' && '£'}
            {record.currency === 'EUR' && '€'}
            {record.currency === 'USD' && '$'}
            {parseFloat(price).toFixed(2)}
          </span>
        )
      },
      {
        title: 'UOM',
        dataIndex: 'unit_of_measure',
        key: 'unit_of_measure',
        width: 80,
      },
      {
        title: 'Lead Time',
        dataIndex: 'lead_time_days',
        key: 'lead_time_days',
        width: 100,
        render: (days) => days ? `${days} days` : '-'
      },
      {
        title: 'Status',
        dataIndex: 'active',
        key: 'active',
        width: 100,
        render: (active) => active ? (
          <Tag icon={<CheckCircleOutlined />} color="success">Active</Tag>
        ) : (
          <Tag icon={<CloseCircleOutlined />} color="default">Inactive</Tag>
        )
      },
      {
        title: 'Actions',
        key: 'actions',
        width: 100,
        render: (text, record) => (
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onClickEditSupplierItem(record)}
          >
            Edit
          </Button>
        )
      },
    ];

    return (
      <div>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Catalog Items ({items.length})</h3>
          <Button type="primary" onClick={onClickNewSupplierItem}>
            Add Catalog Item
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={items}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </div>
    );
  }
}
